var Player = /** @class */ (function () {
    function Player(id, name, color, leftControl, rightControl) {
        this._xPosition = 0;
        this._yPosition = 0;
        this._angle = 0;
        this._isAlive = false;
        this._score = 0;
        this._isTurningLeft = false;
        this._isTurningRight = false;
        this._isActive = false;
        this._id = id;
        this._name = name;
        this._color = color;
        this._leftControl = leftControl;
        this._rightControl = rightControl;
    }
    Object.defineProperty(Player.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "color", {
        get: function () {
            return this._color;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "xPosition", {
        get: function () {
            return this._xPosition;
        },
        set: function (value) {
            this._xPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "yPosition", {
        get: function () {
            return this._yPosition;
        },
        set: function (value) {
            this._yPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "angle", {
        get: function () {
            return this._angle;
        },
        set: function (value) {
            this._angle = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "isAlive", {
        get: function () {
            return this._isAlive;
        },
        set: function (value) {
            this._isAlive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "score", {
        get: function () {
            return this._score;
        },
        set: function (value) {
            this._score = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "isTurningLeft", {
        get: function () {
            return this._isTurningLeft;
        },
        set: function (value) {
            this._isTurningLeft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "isTurningRight", {
        get: function () {
            return this._isTurningRight;
        },
        set: function (value) {
            this._isTurningRight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "leftControl", {
        get: function () {
            return this._leftControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "rightControl", {
        get: function () {
            return this._rightControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (value) {
            this._isActive = value;
        },
        enumerable: true,
        configurable: true
    });
    return Player;
}());
export { Player };
